import {ECalculusStateFilter} from '../../../config/state-filter.enum';
import {EsvgFiles, IControlObject} from 'frontier/nucleus';
import {IPdfBlob} from 'frontier';
import {TShownTables} from '../shown-tables.type';

export interface IProcessState {
  category: ECalculusStateFilter;
  state: ECalculusStateFilter;
}

export interface ICart {
  obj: IControlObject,
  number: string;
  replaced?: true | null;
}

export interface IInvoice {
  obj: IControlObject;
  invoiceId: string;
}

export interface IClient {
  obj: IControlObject;
  name: string;
  replaced?: true | null;
}

export interface IShowCartsTableState {
  ETLnMapping: number;
  arrangeInvoice: number;
  monitorPayment: number;
}

export type TShowCartsTableKey = keyof IShowCartsTableState;

export
type TPdfOverlay =
  'trapo' |
  'invoice' |
  'copaymentInvoice' |
  'collectiveInvoice' |
  'documentOutBox' |
  'detailDocument' |
  'detailTrapoDocument';

export interface IPdfOverlay {
  type: TPdfOverlay;
  data?: IPdfBlob;
}

export interface IProcessOverviewState {
  selectedDocumentOutbox: IControlObject;
  selectedTableIndices: IShowCartsTableState,
  selectedProcess: IProcessState;
  selectedInvoice: IInvoice | null;
  selectedCart: ICart | null;
  selectedClient: IClient | null;
  pdfOverlay: IPdfOverlay | null;
  isPdfLoading: boolean;
  detailsTabIndex: number | null;
  internalNote: string | null;
}

export const tableIconMap: Map<TShownTables, EsvgFiles> = new Map<TShownTables, EsvgFiles>([
  ['carts', EsvgFiles.car],
  ['clients', EsvgFiles.elderly],
  ['documentOutbox', EsvgFiles.document],
  ['openItems', EsvgFiles.money],
])

export interface IShownTableTab {
  icon: EsvgFiles;
  tableName: TShownTables;
}
